export const arrowIcon = () => {
    return (
        <svg
            height={28} widths={28} viewBox="0 0 32 32"
            xmlns="http://www.w3.org/2000/svg">
            <g fill="none" fillRule="evenodd">
                <path d="m0 0h32v32h-32z" />
                <path d="m9.88528137 7.48578644 1.41421353 1.41421356-6.0994949 6.0997864 25.4426407.0002136v2l-25.4286407-.0002136 6.0854949 6.085495-1.41421353 1.4142135-8.48528137-8.4852813.022-.0214272-.022-.0217186z"
                    fill="#FDFDFD"
                    transform="matrix(-1 0 0 -1 32.04264 31.985282)"
                />
            </g>
        </svg>
    );
};

export const arrowDownIcon = () => {
    return (
        <svg width={32} height={32} viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M36.8536 17.1464C37.0488 17.3417 37.0488 17.6583 36.8536 17.8536L23.3536 31.3536C23.1583 31.5488 22.8417 31.5488 22.6464 31.3536L9.14645 17.8536C8.95119 17.6583 8.95119 17.3417 9.14645 17.1464C9.34171 16.9512 9.65829 16.9512 9.85355 17.1464L23 30.2929L36.1464 17.1464C36.3417 16.9512 36.6583 16.9512 36.8536 17.1464Z" fill="var(--dark-brown-color)" />
        </svg>
    );
};

export const arrowUpIcon = () => {
    return (
        <svg width={32} height={32} viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M9.14645 28.8536C8.95118 28.6583 8.95118 28.3417 9.14645 28.1464L22.6464 14.6464C22.8417 14.4512 23.1583 14.4512 23.3536 14.6464L36.8536 28.1464C37.0488 28.3417 37.0488 28.6583 36.8536 28.8536C36.6583 29.0488 36.3417 29.0488 36.1464 28.8536L23 15.7071L9.85355 28.8536C9.65829 29.0488 9.34171 29.0488 9.14645 28.8536Z" fill="var(--dark-brown-color)" />
        </svg>
    );
};
